import randomColor from 'randomcolor';
import convert from 'color-convert';

// Models
import {
  PatronusErrorResponseBody,
  PatronusValidationErrorBody,
} from 'app/shared/models';

// Returns if the color is a suitable background color for white text
// Adapted from here: https://stackoverflow.com/a/3943023/1601268
export const isSuitableBackgroundColor = (colorHex: string): boolean => {
  const [red, green, blue] = convert.hex.rgb(colorHex);
  return red * 0.299 + green * 0.587 + blue * 0.114 < 186;
};

export const generateLabelBackgroundColor = (seed: string): string => {
  let count = 0;
  let currentSeed = seed;
  let currentColor = '#FFF';

  while (!isSuitableBackgroundColor(currentColor) && count < 5) {
    currentColor = randomColor({
      luminosity: 'dark',
      format: 'hex',
      seed: currentSeed,
    });
    currentSeed += '.';
    count += 1;
  }

  return currentColor;
};

// used for more complex loading states to indicate with an id what is loading
export const combineRootActionWithId = (
  rootAction: string,
  id: string | number,
) => {
  return rootAction + String(id);
};
type TypeofReturns =
  | 'string'
  | 'number'
  | 'object'
  | 'boolean'
  | 'undefined'
  | 'bigint'
  | 'function'
  | 'symbol';
export function isArrayOfType(arr: any, type: TypeofReturns) {
  return Array.isArray(arr) && arr.every((val) => typeof val === type);
}

export const humanReadableFileSize = (size?: number) => {
  if (!size) {
    return '';
  }
  const i = Math.floor(Math.log(size) / Math.log(1024));
  const formattedFileSize = (size / 1024 ** i).toFixed(1);
  return `${formattedFileSize} ${['B', 'kB', 'MB', 'GB', 'TB'][i]}`;
};

// Turns the GET params in the URL into an object. Can accept a string like
// ?param1=something&param2=5 or param1=something&param2=5
// Does not do any html decoding
export const searchParamsToObject = (search: string) => {
  const searchParams = search.charAt(0) === '?' ? search.substring(1) : search;
  const paramsKeyValues = searchParams.split('&');
  const toReturn: { [key: string]: string } = {};

  for (let i = 0; i < paramsKeyValues.length; i++) {
    const [key, value] = paramsKeyValues[i].split('=');
    toReturn[key] = `${value}`;
  }

  return toReturn;
};

export const isAuth0Callback = (hash: string) => {
  return /access_token|error/.test(hash);
};

export const isValidationError = (
  errBody: PatronusErrorResponseBody,
): errBody is PatronusValidationErrorBody => {
  return (
    (errBody as PatronusValidationErrorBody | undefined)?.validation_error !==
    undefined
  );
};

// https://docs.unit21.ai/docs/tags
export const TAG_CAP = 1000;
export const getTagLimitReachedError = (tagCount: number) => {
  return `Tag Limit Reached: There is a tag limit per organization of ${TAG_CAP} tags (you have ${tagCount}). Some tags are hidden.`;
};
